export default __webpack_public_path__ + "static/media/icon-menu-candidate.b5cd534d.svg";